<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-6 offset-md-3 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Contacto
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">
            <div class="row">
                <div class=" col-12 col-md-6 offset-md-3">
                    <app-search-client (close)="closeAddClient()"></app-search-client>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div class="container">
    <!-- Header Section -->
    <div class="header-section">
        <h1 class="page-title">
            <i class="fas fa-users"></i>
            Contactos
        </h1>
        <p class="subtitle">Busca y gestiona todos tus contactos de manera fácil y rápida</p>
    </div>

    <!-- Search Section -->
    <div class="search-section">
        <div class="search-input-group">
            <i class="fas fa-search search-icon"></i>
            <input
                type="text"
                [(ngModel)]="search_form"
                class="search-input"
                placeholder="Buscar por nombre, apellido..."
                (keyup.enter)="getPeople(true)"
            >
            <button
                (click)="getPeople(true)"
                [disabled]="submit_disabled"
                class="search-button"
            >
                <span *ngIf="!submit_disabled">
                    <i class="fas fa-search"></i>
                    Buscar
                </span>
                <span *ngIf="submit_disabled">
                    <i class="fa fa-spinner fa-spin"></i>
                    Buscando...
                </span>
            </button>
        </div>
    </div>

    <!-- Results Section -->
    <div *ngIf="people" class="results-section">
        <!-- Results Header -->
        <div class="results-header">
            <h3 class="results-title">Resultados de la búsqueda</h3>
            <div class="results-count">{{rows.length}} de {{people_total}}</div>
        </div>

        <!-- Contacts Grid -->
        <div class="contacts-grid" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" (scrolledUp)="onScrollUp()">

            <!-- Contact Cards -->
            <div
                *ngFor="let item of rows; let i=index"
                class="contact-card"
                [routerLink]="['/console/person/profile/',item?.person?.code]"
            >
                <!-- Avatar -->
                <div
                    class="contact-avatar"
                    [ngClass]="{'active': usersActives[item?.person?.code]}"
                    [style.background-image]="'url(' + (item?.person?.file_selfie?.url || '../assets/public/images/avatar.png') + ')'"
                >
                </div>

                <!-- Contact Info -->
                <div class="contact-info">
                    <div class="contact-name">
                        {{item?.person?.name}} {{item?.person?.lastName}}
                    </div>
                    <div class="contact-identity">
                        {{getIdentity(item)}}
                    </div>
                    <div class="contact-executive" *ngIf="item?.person?.ejecutive">
                        <i class="fas fa-user-tie"></i>
                        Ejecutivo: {{item?.person?.ejecutive?.name}} {{item?.person?.ejecutive?.lastName}}
                    </div>
                </div>

                <!-- Contact Meta -->
                <div class="contact-meta">
                    <div class="contact-date">
                        {{item?.person?.date | date: 'dd/MM/yyyy'}}
                        <br>
                        {{item?.person?.date | date: 'h:mm:ss a'}}
                    </div>
                    <a
                        class="contact-action"
                        [routerLink]="['/console/person/profile/',item?.person?.code]"
                        (click)="$event.stopPropagation()"
                    >
                        <i class="fas fa-arrow-right"></i>
                        Ver perfil
                    </a>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="!loading && rows.length < 1" class="empty-state">
                <i class="fas fa-users"></i>
                <h3>No se encontraron contactos</h3>
                <p>Intenta con otros términos de búsqueda o verifica la información ingresada</p>
            </div>

            <!-- Load More Button -->
            <div *ngIf="!loading && rows.length > 0" class="load-more-container">
                <button type="button" class="load-more-button" (click)="nextRows()">
                    <i class="fas fa-chevron-down"></i>
                    Cargar más contactos
                </button>
            </div>

            <!-- Loading State -->
            <div *ngIf="loading" class="loading-container">
                <div class="loading-spinner"></div>
                <p>Cargando contactos...</p>
            </div>
        </div>
    </div>
</div>
